export const tutorialVideosLoading =  ({store})  => store.tutorialVideosReducer.loading;

export const tutorialVideosError =  ({store})  => store.tutorialVideosReducer.error;

export const tutorialVideosData =  ({store})  => store.tutorialVideosReducer.data;